export default{
  "Mute Video": "Sessiz Video",
  "HitPaw Online Mute Video": "HitPaw Çevrimiçi Sessiz Video",
  "Fast and easy to remove sound from your video online": "Çevrimiçi videonuzdan sesi çıkarmak için hızlı ve kolay",
  "Muting": "Sessize alma",
  "Mute Failed": "Sessiz Başarısız Oldu",
  "Mute New": "Yeni Sessiz"
};